import * as ko from "knockout";
import {ISyncField} from "../../../../../../index";
import {ObjectTypeId, TEXT_WRAPPER_START} from "../../../../../../constants";
import {createErrorMessage, getNextId, getSourceTranslation} from "../../../../../../util/misc";
import {global, lm} from "../../../../../../appContext";
import {nsSyncFields} from "../../../../../../req/nsSyncFields";
import {IRequestObject} from "../../../../../../req/index";
import {nsFa} from "../../../../../fa/fn";
import {AbstractParameter, IAbstractParams} from "./AbstractParameter";
import {ErrorTracker} from "../../../../../../error.tracker";
import {REQUEST_MESSAGE} from "../../../../../../constants/Language";
import i = nsFa.i;
import syncfield_idHtml from './syncfield-id.html?raw';

export let template = syncfield_idHtml;

export class viewModel extends AbstractParameter {
    private readonly req: IRequestObject;
    private readonly syncfield: KnockoutObservable<ISyncField | null> = ko.observable(null);
    private readonly isFocus: KnockoutObservable<boolean> = ko.observable(false);
    private readonly metaidentifier: KnockoutObservable<string> = ko.observable('')
    private silentUpdate: boolean = false;
    private readonly buttonId: string = `button-${getNextId()}`;

    constructor(params: IAbstractParams) {
        super(params);
        this.kosub.subscribe(this.parameter.val, this.initRequest.bind(this));
        this.kosub.subscribe(this.syncfield, () => {
            this.updateObservable();
            this.validate();
        });
        this.kosub.subscribe(this.metaidentifier, () => {
            this.updateObservable();
            this.validate();
        });
        this.req = nsSyncFields.getSyncFields(8);
        this.initRequest();
    }

    private validate() {
        const et: ErrorTracker = global.errorAreas.get('dynamic.properties');
        const a = !!this.syncfield();
        if (!a) {
            et.update(!a, this.syncfield, `invalid synchronization field`);
            return;
        }
        const b = /[\[\]|;]/.test(this.parameter.val());
        if (b) {
            et.update(b, this.syncfield, `contains invalid characters`);
            return;
        }
        et.update(false, this.syncfield);
    }

    private updateObservable() {
        const syncfield = this.syncfield();
        let val: number | string | undefined = syncfield?.syncfieldid;
        if (!syncfield || !val) {
            return;
        }
        if (syncfield.name.startsWith('ExtensionAttribute') && this.metaidentifier()) {
            val = val + '.' + this.metaidentifier();
        }
        this.silentUpdate = true;
        this.parameter.val(val);
        this.silentUpdate = false;
    }

    private initRequest() {
        if (this.silentUpdate) {
            return;
        }
        this.isReady(false);
        this.messageData({message: REQUEST_MESSAGE});
        this.req.request
            .then((data: ISyncField[]) => {
                const val = String(this.parameter.val()).split('.');
                this.syncfield(data.find(sf => sf.syncfieldid == Number(val[0])) ?? null);
                if (this.syncfield()) {
                    this.metaidentifier(val.slice(1).join('.'));
                }
                this.messageData(null);
                this.isReady(true);
            })
            .catch((reason: string) => {
                this.messageData(createErrorMessage(String(reason)))
            })
        ;
    }

    private onPickSyncfieldClick() {
        global.dialogManager.addComponent({
            title: `${i('fa-shapes')} ${lm.t('choose subject|s:((synchronization field|ac))')}`,
            content: {
                name: 'component/dynamic-variable/dialog/pick/syncfield',
                params: {
                    callback: (sf: ISyncField) => {
                        this.syncfield(sf);
                        this.messageData(null);
                        window.requestAnimationFrame(() => document.getElementById(this.buttonId)?.focus());
                    },
                    objectTypeId: ObjectTypeId.FormData,
                    filterFn: (sf: ISyncField) => sf.name.charAt(0) != TEXT_WRAPPER_START,
                    sortFn: (sf: ISyncField) => getSourceTranslation(sf),
                }
            }
        })
    }

    private showMetaIdentifier = ko.pureComputed((): boolean => {
        const syncfield = this.params.dynamicProperties.syncfield();
        const a = !syncfield?.name.includes('BUTTON')
        const b = this.syncfield()?.name.startsWith('ExtensionAttribute');
        return !!(a && b);
    })

    private getSourceTranslation() {
        const syncfield = this.syncfield();
        return syncfield ? getSourceTranslation(syncfield) : '';
    }

    override dispose() {
        super.dispose()
        this.req.promise.abort();
    }
}
